import React from "react";
import "./styles.css";

class Pagination extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      limit: props.limit,
      page: props.page,
    };
  }

  onNext() {
    let { page } = this.state;
    let c_page = page + 1;
    this.setState({
      page: c_page,
    });
    this.props.handlePagination(c_page);
  }

  onPrevious() {
    let { page } = this.state;
    let c_page = page > 1 ? page - 1 : 1;
    this.setState({
      page: c_page,
    });
    this.props.handlePagination(c_page);
  }

  render() {
    let activePages = (this.state.page - 1) * this.props.limit;
    
    const isFirstPage = this.state.page <= 1;
    const totalPages = Math.ceil(this.props.totalItemsCount / this.props.limit);
    const isLastPage = this.state.page >= totalPages;

    if (this.props.totalItemsCount === 0) return <></>;
    return (
      <>
        <div className="container pagination-container">
          <div style={{ flex: 1 }} />
          <div className="pagination-page-controller">
            <div className="form-group">
              <select
                className="form-control"
                onChange={(e) => this.props.handleChangeLimit(e)}
                value={this.props.limit}
              >
                {[10, 50, 100, 500, 1000].map((el, i) => (
                  <option key={i} value={el}>
                    {el}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="pagination-btn-content">
            <div
              className="pagination-item"
              style={{ 
                opacity: isFirstPage ? 0.3 : 1,
                cursor: isFirstPage ? 'not-allowed' : 'pointer'
              }}
              onClick={() => !isFirstPage && this.onPrevious()}
            >
              <i className="fa fa-chevron-left" />
            </div>
            <div className="pagination-counts">
              <span>
                {`${activePages === 0 ? 1 : activePages + 1} - ${
                  Math.min(
                    (this.state.page) * this.props.limit,
                    this.props.totalItemsCount
                  )
                } of ${this.props.totalItemsCount}`}
              </span>
            </div>
            <div
              className="pagination-item"
              style={{ 
                opacity: isLastPage ? 0.3 : 1,
                cursor: isLastPage ? 'not-allowed' : 'pointer'
              }}
              onClick={() => !isLastPage && this.onNext()}
            >
              <i className="fa fa-chevron-right" />
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Pagination;
